/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import MainLayout from '../common/ui/layout/main/MainLayout';
import { Switch, Route, Redirect, useHistory, useLocation } from 'react-router-dom';
import { CircularProgress } from '@material-ui/core';
import MeetingsList from './Meeting/list/MeetingList';
import MeetingProfile from './Meeting/single/MeetingProfile';
import PolicyList from './Policy/list/PolicyList';
import ActionList from './Action/list/ActionList';
import UserList from './User/list/UserList';
import LoginForm from './Login/form/LoginForm';
import { authorizeUser } from './Login/api';

import './App.scss';
import '../common/assets/styles/list-styles.scss';
import '../common/assets/styles/summary-form-styles.scss';

const App = ({ initialSsoError = '' }) => {
    const [logedInUser, setLogedInUser] = useState(null);
    const [isAuthChecking, setIsAuthChecking] = useState(true);
    const location = useLocation();
    const history = useHistory();

    useEffect(() => {
        const fetchLogedInUser = async () => {
            const user = await authorizeUser();
            setLogedInUser(user);
            setIsAuthChecking(false);

            if (!user && location.pathname !== '/login') {
                history.replace(`/login${location.pathname !== '/' ? `?redirect=${location.pathname}` : ''}`);
            } else if (user && location.pathname === '/login') {
                const params = new URLSearchParams(location.search);
                const redirect = params.get('redirect');
                history.replace(redirect || '/');
            }
        };

        fetchLogedInUser();
    }, []);

    if (isAuthChecking) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', padding: '48px' }}>
                <CircularProgress />
            </div>
        );
    }

    const loginSearch = new URLSearchParams();
    if (location.pathname !== '/') {
        loginSearch.set('redirect', location.pathname);
    }
    if (initialSsoError) {
        loginSearch.set('ssoError', initialSsoError);
    }
    const loginPath = `/login${loginSearch.toString() ? `?${loginSearch.toString()}` : ''}`;

    return (
        <MainLayout>
            <Switch>
                {logedInUser ? (
                    <>
                        <Route exact path="/" render={() => <MeetingsList />} />
                        <Route
                            exact
                            path="/meetings/:meetingId/policies/:policyId"
                            render={props => <MeetingProfile {...props} />}
                        />
                        <Route
                            exact
                            path="/meetings/:meetingId/actions/:actionId"
                            render={props => <MeetingProfile {...props} />}
                        />
                        <Route path="/meetings/:meetingId" render={props => <MeetingProfile {...props} />} />
                        <Route exact path="/policies" render={props => <PolicyList {...props} />} />
                        <Route exact path="/policies/:policyId" render={props => <PolicyList {...props} />} />
                        <Route exact path="/actions" render={props => <ActionList {...props} />} />
                        <Route exact path="/actions/:actionId" render={props => <ActionList {...props} />} />
                        <Route exact path="/users" render={props => <UserList {...props} />} />
                        <Redirect to="/" />
                    </>
                ) : (
                    <>
                        <Route
                            exact
                            path="/login"
                            render={props => <LoginForm {...props} initialSsoError={initialSsoError} />}
                        />
                        <Redirect to={loginPath} />
                    </>
                )}
            </Switch>
        </MainLayout>
    );
};

export default App;
